import { pathBuilder } from 'config/paths/index';

export const root = '/admin/facilities';
export default pathBuilder(root);
